import { Map } from "immutable";
import * as React from "react";
import 'intersection-observer';
import { InView } from 'react-intersection-observer';
import { Action, IOWidget, mk_widget, AsyncState, Pair, image } from "widgets-for-react";
import { CMSState, Id, ImageSize, Link } from "../../../../cms/blocks/types.gen";
import { blockInviewHandler } from "../../../../drupal/rendering/inview_utils.mod";
import { getClassName, link, linkWrapper } from "../../../../cms/blocks/utils.gen";
import { ParsedMediaImage, ParsedParagraphQuoteItem } from "../../../../drupal/types_and_parser/types";
import { List } from 'immutable'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from 'swiper';
import { parseImage } from "../../../../drupal/drupal_to_cms.mod";
import { ImageContainer } from "../../../../cms/blocks/widgets/ImageContainer.gen";
import { QuotesBlock, QuotesBlockProps, QuoteSlideProps } from "./quotes";
import { extra_images } from "../../../utils/extra_images.mod";

export type quotesBlockProps = {
  index: number
  field_title: string
  field_quote_items: List<quoteItemBlockProps>
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type quoteItemBlockProps = {
  field_author_name: string
  field_function: string
  field_image?: ParsedMediaImage
  image?: Id
  image_alt?: string
  image_size?: ImageSize<extra_images>
  field_link: Link
  field_quote: string
}

export type quotesBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  quote_classname: string
  footer_classname: string
  author_classname: string
  clickable_classname: string
  visual_classname: string
  image_classname: string
}>

export function quotesBlock<customBlockData>(
  props: quotesBlockProps,
  options?: { style: quotesBlockStyle; key?: string }
): IOWidget<CMSState<customBlockData, extra_images, never>, Action<CMSState<customBlockData, extra_images, never>>> {
  return (cmsState: CMSState<customBlockData, extra_images, never>) =>
    mk_widget({
      run: _ => {
        return (
          <InView
            as="section"
            onChange={(inView) => blockInviewHandler('quotes', inView, `io-${options && options.key ? options.key : props.index}`, getClassName(options, "inview_classname", "inview"))}
            triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
            threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
            id={`io-${options && options.key ? options.key : props.index}`}
            className={"container-fluid bg-light my-5"}
            key={options && options.key ? options.key : `block-${props.index}`}
          >
            {QuotesBlock(
              {
                isStyleguide: false,
                title: props.field_title,
                cmsState: cmsState,
                quotes: props.field_quote_items
                  .map((e, i) =>
                    (
                      {
                        person: e!.field_author_name,
                        person_function: e!.field_function,
                        quote: e!.field_quote,
                        field_image: e!.field_image,
                        btn: e?.field_link?.title != undefined && 
                             e?.field_link?.url != undefined ?
                        {
                          label: e!.field_link.title,
                          url: e!.field_link.url
                        } : undefined,
                        image: e!.image,
                        image_alt: e.image_alt,
                        image_size: e.image_size,

                      }
                    ) as QuoteSlideProps
                  ).toArray(),
              }
            )}
          </InView>
        )
      },
    })
}
